// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclaimer>div{width:625px;border-top:1px solid #d8d8d8;text-align:center;padding:20px 30px;margin:auto auto 100px;max-width:100%}@media(max-width:640px){.disclaimer>div{padding:20px}}.disclaimer>div h4{font-weight:600;font-size:20px;text-transform:uppercase;color:#1f1f1e;line-height:1.5;margin-top:40px;margin-bottom:20px}.disclaimer>div p{line-height:2;font-size:18px}", ""]);
// Exports
module.exports = exports;
